<template>
    <v-row justify="center">
        <v-dialog
            v-model="modal"
            :persistent='true'
            width="1520px"
            height="100%"
            no-click-animation
            >
            <div>
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-container class="mx-2">
                        <v-row no-gutters>
                            <v-col cols="6" :class="labelObj">
                                <div>{{ golfCourseName }}</div>
                                <div>{{ courseName }}</div>
                                <div>{{ playDateStart }} ～ {{ playDateValid }}</div>
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                    class="mr-3"
                                    :items="yearInSelectBox"
                                    item-value="year"
                                    item-text="year"
                                    v-model="search.year"
                                    label="年"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-select
                                    :items="monthInSelectBox"
                                    v-model="search.month"
                                    class="mr-3"
                                    label="月"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    color="primary"
                                    class="ml-5 mt-4"
                                    @click="clickSearch"
                                >検索</v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters>
                            <!-- 変更日付選択 -->
                            <v-col cols="4">
                                <v-radio-group
                                    v-model="search.day"
                                    row
                                >
                                    <v-radio
                                        v-for="d in dayInSelectBox"
                                        :key="d.id"
                                        :label="d.code_name"
                                        :value="d.code"
                                    />
                                </v-radio-group>
                            </v-col>
                            <!-- 日付範囲 -->
                            <v-col cols="2">
                                <v-text-field
                                    maxlength="2"
                                    placeholder="01"
                                    inputmode="tel"
                                    v-model="input.playDateFrom"
                                    :prefix="dateFromPre"
                                    :disabled="search.day !== 4"
                                    :rules="[
                                        rules.format_date,
                                        rules.correctDateBetween
                                    ]"
                                >
                                    <template v-slot:append-outer>
                                        <span class="mt-2">~</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    class="px-3"
                                    maxlength="2"
                                    placeholder="01"
                                    inputmode="tel"
                                    :prefix="dateToPre"
                                    v-model="input.playDateTo"
                                    :disabled="search.day !== 4"
                                    :rules="[
                                        rules.format_date,
                                        rules.correctDateBetween
                                    ]"
                                />
                            </v-col>
                        </v-row>
                        <v-form ref="form">
                            <v-row no-gutters>
                                <v-col cols="2">
                                    <v-text-field
                                        class="px-3"
                                        maxlength="2"
                                        label="時間指定"
                                        type="time"
                                        v-model="input.playStartFrom"
                                        :rules="[rules.required]"
                                    >
                                        <template v-slot:append-outer>
                                            <span class="mt-2">~</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="2">
                                    <v-text-field
                                        class="px-3"
                                        maxlength="2"
                                        label="時間指定"
                                        type="time"
                                        v-model="input.playStartTo"
                                        :rules="[rules.required]"
                                    />
                                </v-col>
                                <v-col cols="2">
                                    <v-select
                                        :items="statusInSelectBox"
                                        item-value="code"
                                        item-text="code_name"
                                        label="枠ステータス"
                                        v-model="input.status"
                                    />
                                </v-col>
                                <v-col cols="2" offset="3">
                                    <v-btn
                                        class="px-3"
                                        color="primary"
                                        @click="isChangeStatus"
                                    >指定した条件で変更</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                    <v-data-table
                        :headers="headers"
                        :items="desserts"
                        hide-default-footer
                        class="elevation-1"
                        disable-pagination
                        fixed-header
                    >
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.displayPlayStart }}</td>
                                <template v-for="(cell, i, day) in item.days">
                                    <td :key="cell.key">
                                        <v-select
                                            v-if="cell.flg !== null"
                                            :items="statusInSelectBox"
                                            item-value="code"
                                            item-text="code_name"
                                            :disabled="cell.flg !== '0'"
                                            v-model="cell.status"
                                            @change="createSendData(cell.key, day + 1, item.play_start, item.course_code, $event)"
                                        />
                                        <!--
                                        <input
                                            type="checkbox"
                                            v-model="cell.releaseFlag"
                                            v-if="cell.releaseFlag !== null"
                                            @click="createSendData(cell.key, day + 1, item.play_start, item.course_code, !cell.releaseFlag)"
                                        >
                                        -->
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-4" text @click="statusCloseModal">閉じる</v-btn>
                        <v-btn
                            color="green darken-4"
                            text
                            :disabled="SendEmptyReturnTrue"
                            @click="displayAddOverLay">更新</v-btn>
                    </v-card-actions>
                    <AddOverlay
                        page-name="予約連携ステータス変更"
                        @processing="updateReleaseFlag"
                        @cancel="closeAddOverLay"
                        :process-result="process"
                        :OverlaySwitch="addOverlay"
                    />
                </v-card>
            </div>
        </v-dialog>
    </v-row>
</template>

<script>
/**
 * 予約連携ステータス変更画面
 */
import validater from '@/lib/validater';
import CardTitle from '@/components/module/CardTitle';
import AddOverlay from '@/components/overlay/AddOverlay';
// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { utilityMixin } from '@/mixins/utility';
// graghql
import { CODE_MASTER } from '@/views/config';
import { GET_LINK_YEARS } from '@/constants/reserve';
import {
    GET_CELL_BASE,
    GET_CELL_BASE_RESERVE_STATUS,
    UPDATE_RESERVE_STATUS_TO_CELL_LINKS
} from '@/constants/cell_bases';
import { GET_CODE_LIST } from '@/constants/codelist';

export default {
    components: {
        CardTitle,
        AddOverlay
    },
    mixins: [
        authorityMixin,
        utilityMixin
    ],
    props: {
        id: {
            type: String
        },
        modal: {
            type: Boolean
        }
    },
    data () {
        return {
            addOverlay: false,
            golfGroupCode: process.env.VUE_APP_GROUP_CODE,
            // 年の選択ボックス
            yearInSelectBox: [],
            // 月の選択ボックス
            monthInSelectBox: [],
            // 日の選択ボックス
            dayInSelectBox: [
                { code: 1, code_name: '全日' },
                { code: 2, code_name: '平日' },
                { code: 3, code_name: '休日' },
                { code: 4, code_name: '期間指定' }
            ],
            // 枠ステータスの選択ボックス
            statusInSelectBox: [],
            // 検索値
            search: {
                year: '',
                month: '',
                day: 1
            },
            // 入力値
            input: {
                playDateFrom: '',
                playDateTo: '',
                playStartTo: '',
                playStartFrom: '',
                status: '1'
            },
            process: {
                // 処理結果
                result: '',
                // 処理結果メッセージ
                resultText: '',
                // 処理中かどうか
                processing: false
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [],
            // 送信するデータ
            sendData: [],
            // 週のデータ
            dayOfWeek: [
                { id: CODE_MASTER.SUNDAY['id'], name: CODE_MASTER.SUNDAY['name'] },
                { id: CODE_MASTER.MONDAY['id'], name: CODE_MASTER.MONDAY['name'] },
                { id: CODE_MASTER.TUESDAY['id'], name: CODE_MASTER.TUESDAY['name'] },
                { id: CODE_MASTER.WEDNESDAY['id'], name: CODE_MASTER.WEDNESDAY['name'] },
                { id: CODE_MASTER.THURSDAY['id'], name: CODE_MASTER.THURSDAY['name'] },
                { id: CODE_MASTER.FRIDAY['id'], name: CODE_MASTER.FRIDAY['name'] },
                { id: CODE_MASTER.SATURDAY['id'], name: CODE_MASTER.SATURDAY['name'] }
            ],
            // モーダルタイトル コンポーネントに渡す値：モーダルタイトル
            page_title: '予約連携ステータス変更',
            // ゴルフ場コード
            golfCode: '',
            // ゴルフ場名
            golfCourseName: '',
            // コースコード
            courseCode: '',
            // コース名
            courseName: '',
            // プレー開始日;
            playDateStart: '',
            // プレー終了日;
            playDateValid: '',
            // ボタンの活性・非活性
            btn: [
                { element_id: '000', element_name: '画面', isActive: true },
                { element_id: '001', element_name: '検索', isActive: true },
                { element_id: '002', element_name: '更新', isActive: true }
            ],
            vue_id: 'SCR0028',
            count: 0,
            offset: 0,
            dateFromPre: '',
            dateToPre: '',
            // 枠内容の表示箇所のクラス指定
            labelObj: {
                'justify-start': true,
                'align-self-center': true,
                'py-2': true,
                'wordKeep': true
            },
            rules: {
                // 必須項目
                required: value => !!value || this.$t('error.validation.required.any'),
                format_date: value => validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // 期間指定専用
                correctDateBetween: value => this.checkCorrectDate(value) || this.$t('error.validation.date.Correct')
            }
        };
    },
    async created () {
    },
    watch: {
        // 親からデータが渡ってきたときに発火
        result () {
            if (this.process.result === 1) {
                this.process.resultText = this.$t('result.success.change');
            } else if (this.result === 0) {
                this.process.resultText = this.$t('result.error.change');
            }
        },
        // 日付
        search: {
            handler (val) {
                this.dateFromPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
                this.dateToPre = this.search.year + '-' + this.search.month.padStart(2, '0') + '-';
            },
            deep: true
        },
        // 画面表示
        modal (val) {
            // 子画面表示時のみ実行
            if (val === true) {
                this.Initialize();
            }
        }
    },
    computed: {
        formatedTimeFrom () {
            if (this.input.playStartFrom.length === 2) {
                return this.input.playStartFrom + ':';
            }
            return this.input.playStartFrom;
        },
        formatedTimeTo () {
            if (this.input.playStartTo.length === 2) {
                return this.input.playStartTo + ':';
            }
            return this.input.playStartTo;
        },
        SendEmptyReturnTrue () {
            return this.sendData.length === 0;
        }
    },
    methods: {
        /** ----------------------------------------------
         * 初期化処理
         * ---------------------------------------------- */
        async Initialize () {
            this.$store.commit('loading/setIsOpacityLoading', true);

            // プルダウンに表示する値の取得
            return Promise.resolve()
                .then(function () {
                    // IDがある場合、基本枠情報を取得
                    if (this.id !== '' && this.id !== null) {
                        return this.getDetail(this.id);
                    }
                    // ない場合は終了
                    this.$store.commit('loading/setIsOpacityLoading', false);
                }.bind(this)).then(function () {
                    // 年
                    return this.getLinkYears();
                }.bind(this)).then(function () {
                    // 月
                    for (let i = 1; i <= 12; i++) {
                        this.monthInSelectBox.push(String(i));
                    }
                    // 枠ステータス
                    return this.getReserveStatus();
                }.bind(this)).then(function () {
                    // 表示する年月を取得
                    let now = new Date();
                    let nowYear = now.getFullYear();
                    let nowMonth = now.getMonth() + 1;
                    this.$set(this.search, 'year', String(nowYear));
                    this.$set(this.search, 'month', String(nowMonth));

                    // 初期値に戻す
                    this.$set(this.search, 'day', 1);
                    this.$set(this.search, 'playDateFrom', '');
                    this.$set(this.search, 'playDateTo', '');
                    this.$set(this.search, 'playStartTo', '');
                    this.$set(this.search, 'playStartFrom', '');

                    // 変更指定用の枠ステータスの表示初期値
                    this.$set(this.input, 'status', '1');

                    // ローディング削除
                    this.$store.commit('loading/setIsOpacityLoading', false);
                }.bind(this));
        },
        /** ----------------------------------------------
         * 詳細取得
         * ---------------------------------------------- */
        async getDetail (id) {
            return new Promise(function (fulfilled, rejected) {
                this.$apollo.query({
                    query: GET_CELL_BASE,
                    fetchPolicy: 'no-cache',
                    variables: { id: id }
                }).then(res => {
                    const detail = res.data.getCellBaseDetail;

                    // 画面に表示
                    this.golfCourseName = detail.golf_name;
                    this.courseName = detail.course_name;
                    this.playDateStart = detail.play_date_start;
                    this.playDateValid = detail.play_date_valid;
                    this.golfCode = detail.golf_code;
                    this.courseCode = detail.course_code;

                    return fulfilled(true);
                }).catch(e => {
                    this.result = e;
                    this.resultText = e;
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
            }.bind(this));
        },
        /** --------------------------------------------
         * 枠ステータスを取得
         *-------------------------------------------- */
        async getReserveStatus () {
            return new Promise(function (fulfilled, rejected) {
                this.$apollo.query({
                    query: GET_CODE_LIST,
                    variables: {
                        code_key: 'reserve_status',
                        default_display: 0
                    }
                }).then(res => {
                    // 枠ステータスを格納
                    this.statusInSelectBox = res.data.GetCodeList.CodeList;
                    return fulfilled(true);
                }).catch(e => {
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
            }.bind(this));
        },
        /** --------------------------------------------
        * 検索ボタン処理
        *-------------------------------------------- */
        async getCellBaseReserveStatusList () {
            this.$store.commit('loading/setIsOpacityLoading', true);
            // 検索で指定した日付でヘッダーを作成
            this.makeHeaders();
            // 値をリセット
            this.desserts.splice(0, this.desserts.length);
            // セルの情報を取得
            const records = await this.getCellBaseReserveStatus();

            // 表示用に整形
            let key = 0;
            if (records) {
                records.forEach(record => {
                    Object.keys(record.days).forEach(function (day, index) {
                        if (day === '__typename') return delete record.days[day];

                        let release = record.days[day];
                        release = (release === null) ? { 'flg': null, 'status': null } : release;
                        // 表示用に分割
                        record.days[day] = {
                            'key': key,
                            'flg': release.flg,
                            'status': release.status,
                            'day': index + 1
                        };
                        key++;
                    });
                    // 表示用の配列に格納
                    this.desserts.push(record);
                });
            }
            this.$store.commit('loading/setIsOpacityLoading', false);
        },
        /** --------------------------------------------
        * ヘッダーを作成
        *-------------------------------------------- */
        makeHeaders () {
            const targetDays = new Date(this.search.year, this.search.month, 0).getDate();
            let dayList = [{ text: '時間', aligh: 'center', value: 'play_start', sortable: false, class: 'playStart' }];
            for (let i = 1; i <= targetDays; i++) {
                let targetDate = new Date(`${this.search.year}-${this.search.month}-${i}`);
                let targetDay = this.dayOfWeek[targetDate.getDay()]['name'];

                dayList.push({
                    text: [('0' + i).slice(-2), targetDay].join('\n'),
                    align: 'center',
                    sortable: false,
                    value: 'day' + i,
                    class: 'dayWidth' + this.judgeDay(targetDate)
                });
            }
            this.headers = dayList;
        },
        /** --------------------------------------------
        * 表のセル情報を取得
        * -------------------------------------------- */
        getCellBaseReserveStatus () {
            return this.$apollo.mutate({
                mutation: GET_CELL_BASE_RESERVE_STATUS,
                variables: {
                    id: this.id,
                    year: this.search.year,
                    month: this.search.month.padStart(2, '0')
                }
            }).then(res => {
                for (let release of res.data.getCellBaseReserveStatus) {
                    release.displayPlayStart = this.timeFormated(release.play_start);
                }
                return res.data.getCellBaseReserveStatus;
            });
        },
        timeFormated (data) {
            const time = data.split(':');
            return time[0] + ':' + time[1];
        },
        /** --------------------------------------------
        * 更新処理
        * -------------------------------------------- */
        updateReleaseFlag () {
            this.$store.commit('loading/setIsOpacityLoading', true);

            // 更新開始
            this.$apollo.mutate({
                mutation: UPDATE_RESERVE_STATUS_TO_CELL_LINKS,
                variables: {
                    releaseCellBaseInput: this.sendData
                }
            }).then(res => {
                const result = res.data.updateReserveStatusToCellLinks.result;
                if (result !== 0) {
                    this.closeAddOverLay();
                    this.sendData.splice(0, this.sendData.length);
                    this.$store.commit('loading/setIsOpacityLoading', false);
                } else if (result === 0) {
                    throw new Error('更新する情報がありませんでした。');
                }
            }).catch(error => {
                const e = error.message.split(':');
                this.$set(this.process, 'result', 0);
                this.$set(this.process, 'resultText', e[0]);
                this.$store.commit('loading/setIsOpacityLoading', false);
            });
        },
        /** --------------------------------------------
        * 指定した条件で変更 処理
        * -------------------------------------------- */
        isChangeStatus () {
            if (this.$refs.form.validate()) {
                // 変更する時間の範囲
                const fromTime = this.input.playStartFrom + ':' + '00';
                const toTime = this.input.playStartTo + ':' + '00';

                // 日時一覧の繰り返し
                this.desserts.forEach(record => {
                    // プレー時間
                    const playTime = record['play_start'];
                    // プレー時間が指定した変更する時間の範囲内だった場合は変更を行う
                    if (fromTime <= playTime && playTime <= toTime) {
                        // 日付で繰り返し
                        Object.keys(record.days).forEach(day => {
                            // ステータスとフラグを取得
                            let dayObj = record.days[day];
                            // 現在指定している日付
                            let now = new Date(`${this.search.year}-${this.search.month}-` + (('0' + dayObj.day).slice(-2)));
                            // 祝日を取得
                            let holiday = this.judgeDay(now);
                            // 現在の曜日を取得
                            const weekDay = String(now.getDay());

                            // 変更日付フラグで処理を分岐
                            // 全日
                            if (this.search.day === 1) {
                                // 無条件で反映
                                this.createDateObj(record, dayObj);
                            // 平日
                            } else if (this.search.day === 2) {
                                // 土日ではない場合
                                if (weekDay !== CODE_MASTER.SUNDAY['id'] && weekDay !== CODE_MASTER.SATURDAY['id']) {
                                    // 祝日ではない場合
                                    if (holiday !== 0) {
                                        // 反映
                                        this.createDateObj(record, dayObj);
                                    }
                                }
                            // 休日
                            } else if (this.search.day === 3) {
                                // 土日もしくは祝日の場合
                                if (weekDay === CODE_MASTER.SUNDAY['id'] || weekDay === CODE_MASTER.SATURDAY['id'] || holiday === 0) {
                                    // 反映
                                    this.createDateObj(record, dayObj);
                                }
                            // 期間指定
                            } else if (this.search.day === 4) {
                                // 指定した期間の範囲を取得
                                const fromDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateFrom}`).getTime();
                                const toDate = new Date(`${this.search.year}-${this.search.month}-${this.input.playDateTo}`).getTime();

                                // 変更する時間の範囲以内の場合
                                const nowDate = new Date(now).getTime();
                                if (fromDate <= nowDate && nowDate <= toDate) {
                                    this.createDateObj(record, dayObj);
                                }
                            }
                        });
                    }
                });
            }
        },
        /** --------------------------------------------
        * 送信データ作成関数
        *-------------------------------------------- */
        createSendData (key, date, time, courseCode, status) {
            // 同じキーを検索
            const someKey = this.sendData.findIndex(el => el.key === key);
            // 日にちをフォーマットする
            const formatDay = this.formatedDate(date);
            if (someKey !== -1) {
                // キーが同じものがある場合、古いものを削除
                this.sendData.splice(someKey, 1);
            }

            // 作成
            this.sendData.push({
                golf_group_code: this.golfGroupCode,
                golf_code: this.golfCode,
                key: key,
                course_code: courseCode,
                date: formatDay,
                play_start: time,
                status: status
            });
        },
        /** --------------------------------------------
        * 指定した条件で変更 にて一括で変換したデータを 送信データ作成関数へ投げる
        * -------------------------------------------- */
        createDateObj (record, dayObj) {
            // 変更化のもののみ
            if (dayObj.flg === '0') {
                // ステータスを選択したものにする
                dayObj['status'] = this.input.status;
                this.createSendData(dayObj['key'], dayObj.day, record['play_start'], record['course_code'], this.input.status);
            }
        },
        /** --------------------------------------------
        * フォーマットされた日付を作成する 例:2020-08-01
        * -------------------------------------------- */
        formatedDate (date) {
            return this.search.year + '-' +
                   this.search.month.padStart(2, '0') + '-' +
                   String(date).padStart(2, '0');
        },
        /** --------------------------------------------
        * 検索ボタン処理
        * -------------------------------------------- */
        clickSearch () {
            this.$refs.form.resetValidation();
            this.getCellBaseReserveStatusList();
        },
        /** ----------------------------------------------
         * 変更確認モーダル画面を表示する処理
         * ---------------------------------------------- */
        displayAddOverLay () {
            this.addOverlay = true;
        },
        /** ----------------------------------------------
         * 変更確認モーダル画面を閉じる
         * ---------------------------------------------- */
        closeAddOverLay (item) {
            this.process.result = '';
            this.addOverlay = false;
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        statusCloseModal () {
            this.$refs.form.resetValidation();
            // 送信用データを空にする
            this.sendData.splice(0, this.sendData.key);
            // 枠データを空にする
            this.desserts.splice(0, this.desserts.length);
            this.$emit('refresh-event');
        },
        /** ----------------------------------------------
         * 指定可能年取得
         * ---------------------------------------------- */
        getLinkYears () {
            return new Promise(function (fulfilled, rejected) {
                this.$apollo.mutate({
                    mutation: GET_LINK_YEARS,
                    variables: { golfGroupCode: process.env.VUE_APP_GROUP_CODE }
                }).then(res => {
                    // 年
                    let years = res.data.GetLinkYears.YearList;
                    this.yearInSelectBox.push(...years);
                    return fulfilled(true);
                }).catch(error => {
                    this.result = 0;
                    this.error = error;
                    this.$store.commit('loading/setIsOpacityLoading', false);
                });
            }.bind(this));
        },
        /** ----------------------------------------------
         * 期間指定実在日チェック
         * ---------------------------------------------- */
        checkCorrectDate (str) {
            if (str) {
                let day = this.dateFromPre + str;
                var delim = '-';
                var arr = day.split(delim);
                if (arr.length !== 3) return false;
                if (arr[0] < 1900) return false;
                const date = new Date(arr[0], arr[1] - 1, arr[2]);
                if (arr[0] !== String(date.getFullYear()) || arr[1] !== ('0' + (date.getMonth() + 1)).slice(-2) || arr[2] !== ('0' + date.getDate()).slice(-2)) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }
    }
};
</script>

<style scoped>

    .v-data-table ::v-deep .v-data-table__wrapper{
        overflow: hidden;
        overflow-y: scroll;
        overflow-x: scroll;
        display: block;
        /* white-space: nowrap; */
        -webkit-overflow-scrolling: touch;
        min-height: 200px;
        max-height: 450px;
        width: 100%;
        text-align: center;
    }
    div.v-input--radio-group__input{
        flex-wrap: nowrap;
    }

    .v-radio ::v-deep label{
        word-break: keep-all;
    }

    .v-data-table ::v-deep .wordKeep{
        word-break: keep-all;
    }

    .v-data-table ::v-deep .playStart {
        width: 125px;
    }

    /* 曜日によって色変え */
    .v-data-table ::v-deep th.dayWidth0 {
        padding: 11px;
        color: #DD0000 !important;
    }
    .v-data-table ::v-deep th.dayWidth1,
    .v-data-table ::v-deep th.dayWidth2,
    .v-data-table ::v-deep th.dayWidth3,
    .v-data-table ::v-deep th.dayWidth4,
    .v-data-table ::v-deep th.dayWidth5 {
        padding: 11px;
    }
    .v-data-table ::v-deep th.dayWidth6 {
        padding: 11px;
        color: #0000CC !important;
    }

    table .v-select {
        min-width: 155px;
    }
    .v-data-table ::v-deep th span {
        white-space: pre-wrap;
        word-wrap: break-word;
    }
</style>
